import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { messages } from '../../i18n/messages';

import './Loading.scss';

const propTypes = {

	/**
	 * True, if the content to display is still loading.
	 */
	isLoading: PropTypes.bool.isRequired,

	/**
	 * The font-awesome sizing class (if any) for the icon.
	 */
	size: PropTypes.string.isRequired,

	/**
	 * The content to display.
	 */
	children: PropTypes.node,

};

const defaultProps = {
	isLoading: false,
	size: 'fa-2x',
};

/**
 * Shared component to render a basic TechChange-style loading container for content,
 * which shows loading indicator if isLoading=true, otherwise shows the children.
 *
 * The font-awesome icon will have a default size of 2x, if none is specified.
 *
 * @param {Object} props The props.
 *
 * @returns {Object} The rendered component.
 */
const Loading = (props) => {

	const {
		isLoading,
		size,
		children,
		...restProps
	} = props;

	const intl = useIntl();

	if (isLoading) {

		return (
			<div
				{...restProps}
				className={`tc-loading-spinner ${restProps.className || ''}`}>
				<i
					className={`fas fa-circle-notch fa-spin ${size}`}
					role="alert"
					aria-label={intl.formatMessage(
						messages.TC_COMPONENTS_GENERAL_LOADING_LABEL
					)} />
			</div>
		);

	}

	return children;

};

Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;

export default Loading;
